import { LoanDocument } from '../types/withdraw';

export const reAppLenders = ['UWM', 'Sample Bank', 'Demo Home Loans', 'Placeholder Mortgage Co.', 'Test Credit Union'];

export const newLoanNumber = 'TEST-000124';

export const originalLoanDocuments: LoanDocument[] = [
  { id: 'd1', name: 'Loan application (1003)', meta: 'PDF · Sep 18, 2026' },
  { id: 'd2', name: 'Credit report', meta: 'PDF · Sep 19, 2026' },
  { id: 'd3', name: 'W-2s (2024–2025)', meta: '2 files · Sep 22, 2026' },
  { id: 'd4', name: 'Pay stubs', meta: '3 files · Oct 1, 2026' },
  { id: 'd5', name: 'Bank statements', meta: '2 files · Oct 2, 2026' },
  { id: 'd6', name: 'Purchase agreement', meta: 'PDF · Sep 15, 2026' },
  { id: 'd7', name: 'Photo ID', meta: 'JPG · Sep 18, 2026' },
];
